import { ChangeEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { slugifyExtended } from 'modules/CreateNewRoomModal/CreateRoomStepModal/AliasField/utils';
import RoomNameInput from 'modules/CreateNewRoomModal/CreateRoomStepModal/RoomNameInput';

import { ScheduleMeetingFormValues } from './types';

const ScheduleMeetingRoomNameField = () => {
  const { t } = useTranslation();
  const {
    control,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext<ScheduleMeetingFormValues>();

  const hasSlugChanged = watch('hasSlugChanged');

  return (
    <Controller
      name="name"
      control={control}
      render={({ field: { onChange, value } }) => {
        const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
          if (!hasSlugChanged) {
            setValue('slug', slugifyExtended(e.target.value), { shouldDirty: true });
          }
          onChange(e.target.value);
        };

        return (
          <RoomNameInput
            value={value}
            onChange={handleChange}
            errorMessage={errors.name?.message ? t(errors.name.message) : undefined}
            placeholder={t('schedule_meeting.name_placeholder')}
          />
        );
      }}
    />
  );
};

export default ScheduleMeetingRoomNameField;
